import {
  Notifications,
  ClientSideNotifications,
  ErrorNotifications,
  NotificationsChat,
} from 'types';

export const defaultListeners = Object.keys(Notifications).reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: [],
  }),
  {},
);

export const defaultChatListeners = Object.keys(NotificationsChat).reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: [],
  }),
  {},
);

export const clientSideConnectionListeners = Object.values(ClientSideNotifications).reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: [],
  }),
  {},
);

export const chatClientSideConnectionListeners = Object.values(ClientSideNotifications).reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: [],
  }),
  {},
);

export const errorListeners = Object.values(ErrorNotifications).reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: [],
  }),
  {},
);

export const chatErrorListeners = Object.values(ErrorNotifications).reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: [],
  }),
  {},
);
